const colors = {
    black: "#000",
    charcoal: "#404040",
    orange: "#EF602F",
    red: "#CF1B2C",
    redLight: "#E84A5A",
    redOff: "#FFEBED",
    redPastel: "#EBB3B3",
    green: "#26A200",
    greenDark: "#408135",
    greenLime: "#C8E7BF",
    greenYellow: "#867B1D",
    greenPastel: "#C6D9C3",
    greyDark: "#707070",
    greyLight: "#D9D9D9",
    greyLighter: "#B7B7B7",
    greyLightest: "#f2f2f2",
    greyMedium: "#868686",
    white: "#FFF",
    whiteOff: "#f8f8f8",
    salmon: "#E78D95",
    blue: "#1592E6",
    blueDeep: "#325981",
    blueLight: "#E3F0FB",
    bluePastel: "#AAE1F9",
    yellowLight: "#F1E89E",
};

export default colors;
